export default [
    {
      path: '/supplier/view/:id',
      name: 'supplier-view',
      component: () => import('@/views/supplier/supplierView.vue'),
      meta: {
        resource: 'Auth',
        action: 'read'
      },
    },
    // 員工埋數用
    {
      path: '/staff-supplier/list',
      name: 'staff-supplier-list',
      component: () => import('@/views/supplier/suppliers-list/suppliersList.vue'),
      meta: {
        resource: 'staff_suppliers',
        action: 'read'
      },
    },
    // 員工埋數用
    {
      path: '/staff-supplier/view/:id',
      name: 'staff-supplier-view',
      component: () => import('@/views/supplier/supplierView.vue'),
      meta: {
        resource: 'staff_suppliers',
        action: 'view_detail'
      },
    },
    //設置用
    // {
    //   path: '/setting-supplier/view/:id',
    //   name: 'setting-supplier-view',
    //   component: () => import('@/views/supplier/supplierView.vue'),
    //   meta: {
    //     resource: 'setting_suppliers',
    //     action: 'view_detail'
    //   },
    // },
    // 供應商帳單列表
    {
      path: '/supplier-documents/list',
      name: 'supplier-documents-list',
      component: () => import('@/views/supplier/supplier-documents-list/supplierDocumentsList.vue'),
      meta: {
        resource: 'staff_supplier_documents',
        action: 'read'
      },
    },
    // 供應商帳單明細列印
    {
      path: '/supplier-bill-detail-print/:id',
      name: 'supplier-bill-detail-print',
      component: () => import('@/views/supplier/bill-detail-print/SupplierBillDetailPrint.vue'),
      meta: {
        resource: 'staff_supplier_documents',
        action: 'view_detail'
      },
    },
]